import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

export default function Dialog (props)
{
    const cancelTitle = props.cancelTitle === undefined ? "Annuler" : props.cancelTitle;
    const confirmTitle = props.confirmTitle === undefined ? "Confirmer" : props.confirmTitle;

    const cancel = props.cancel === undefined ? props.hide : props.cancel;
    const confirm = props.confirm === undefined ? props.hide : props.confirm;
    
    return (
	<Modal
	    show={props.show}
	    onHide={props.hide}
	    backdropClassName="backdrop-second"
	>
	    <Modal.Header className="bg-light" closeButton>
		<Modal.Title>{props.title}</Modal.Title>
	    </Modal.Header>
	    <Modal.Body>
		{props.children}
		<div className="d-flex justify-content-end gap-2">
		    {props.cancel !== undefined && (<Button variant="secondary" size="md" onClick={() => { props.hide(); cancel(); }}>{cancelTitle}</Button>)}
		    {props.confirm !== undefined && (<Button variant="primary" size="md" onClick={() => { props.hide(); confirm(); }}>{confirmTitle}</Button>)}
		</div>
	    </Modal.Body>
	</Modal>
    );
}
